import React from 'react';
import { SearchIcon } from 'lucide-react';
interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}
export function SearchField({
  value,
  onChange,
  placeholder = 'Søg…',
  className = ''
}: SearchFieldProps) {
  return <div className={`relative ${className}`} data-id="element-610" data-mp="w55nu53pepvy">
      <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-stone-400" aria-hidden data-id="element-611" data-mp="w4covqazl4od" />
      <input type="search" value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} aria-label={placeholder} className="w-full rounded-lg border border-stone-200 bg-white py-2 pl-9 pr-3 text-sm outline-none transition-colors placeholder:text-stone-400 focus:border-transparent focus:ring-2 focus:ring-brand-500" data-id="element-612" data-mp="meaxaojfd44p" />
    </div>;
}